/**
 * Global "Start your fundraiser" modal.
 *
 * Trigger the modal from any button/link by either:
 *   - setting its link URL to "#fundraiser-modal", or
 *   - adding the class "js-fundraiser-modal" to the element.
 */

/* global jQuery */

jQuery(document).ready(function ($) {
  const $modal = $('#fundraiser-modal');
  const $overlay = $('.fundraiser-modal__overlay');

  if (!$modal.length) {
    return;
  }

  const $body = $('body');
  let $lastTrigger = null;

  function openModal($trigger) {
    $lastTrigger = $trigger || null;

    $modal.removeAttr('hidden');
    $overlay.removeAttr('hidden');

    requestAnimationFrame(function () {
      $modal.addClass('is-active');
      $overlay.addClass('is-active');
    });

    $body.addClass('modal-open');
    $modal.find('.fundraiser-modal__close').trigger('focus');
  }

  function closeModal() {
    $modal.removeClass('is-active');
    $overlay.removeClass('is-active');

    $modal.one('transitionend', function () {
      $(this).attr('hidden', '');
    });
    $overlay.one('transitionend', function () {
      $(this).attr('hidden', '');
    });

    $body.removeClass('modal-open');

    if ($lastTrigger) {
      $lastTrigger.trigger('focus');
      $lastTrigger = null;
    }
  }

  // Open: links pointing to #fundraiser-modal, or elements with the class.
  $(document).on('click', 'a[href$="#fundraiser-modal"], .js-fundraiser-modal', function (e) {
    e.preventDefault();
    openModal($(this));
  });

  // Close: X button
  $(document).on('click', '.fundraiser-modal__close', function () {
    closeModal();
  });

  // Close: clicking the overlay
  $(document).on('click', '.fundraiser-modal__overlay', function () {
    closeModal();
  });

  // Close: Escape key
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $modal.hasClass('is-active')) {
      closeModal();
    }
  });
});
